import type { StateCreator } from 'zustand';
import type { LibraryTab, LibraryItem } from '@/types';

import type { LibrarySlice } from './types';

export type { LibrarySlice } from './types';

export const libraryInitialState = {
  libraryTabs: [] as LibraryTab[],
  activeTabSlug: null as string | null,
  libraryItems: [] as LibraryItem[],
  isLibraryLoading: false,
  hasAutoSelectedPreset: false,
  shouldScrollToActiveTab: false,
  seeAllCategorySlug: null as string | null,
  seeAllCategoryTitle: null as string | null,
};

export const createLibrarySlice: StateCreator<
  LibrarySlice,
  [],
  [],
  LibrarySlice
> = (set) => ({
  ...libraryInitialState,

  setLibraryTabs: (libraryTabs) => set({ libraryTabs }),
  setActiveTabSlug: (activeTabSlug) => set({ activeTabSlug }),
  setLibraryItems: (libraryItems) => set({ libraryItems }),
  setIsLibraryLoading: (isLibraryLoading) => set({ isLibraryLoading }),
  setHasAutoSelectedPreset: (hasAutoSelectedPreset) =>
    set({ hasAutoSelectedPreset }),
  setShouldScrollToActiveTab: (shouldScrollToActiveTab) =>
    set({ shouldScrollToActiveTab }),
  setSeeAllCategorySlug: (seeAllCategorySlug) => set({ seeAllCategorySlug }),
  setSeeAllCategoryTitle: (seeAllCategoryTitle) => set({ seeAllCategoryTitle }),
});
